import { render, staticRenderFns } from "./Industrial.vue?vue&type=template&id=d8d31bbe&scoped=true"
import script from "./Industrial.vue?vue&type=script&lang=js"
export * from "./Industrial.vue?vue&type=script&lang=js"
import style0 from "./Industrial.vue?vue&type=style&index=0&id=d8d31bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d31bbe",
  null
  
)

export default component.exports